import { ColoursObj, Typography } from '@eventr/common-storybook'
import { useShallow } from 'zustand/react/shallow'
import { useBoundStore } from '../../../../state/bound.store'
import { windowSizes } from '../../../../state/windowState/windowSignals'

export default function FullScreenItineraryTitle() {
    const { getEventInfoV2 } = useBoundStore(
        useShallow((s) => {
            return {
                getEventInfoV2: s.getEventInfoV2,
            }
        })
    )

    return (
        <div
            style={{
                width: '100vw',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignContent: 'center',
                alignItems: 'center',
                zIndex: 900,
                position: 'absolute',
                top: windowSizes.value.insets.insets.top + 16,
                left: 0,
            }}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '48px',
                    backgroundColor: ColoursObj.shades.shade4,
                    borderRadius: '24px',
                    maxWidth: '168px',
                    padding: '0 24px',
                }}
            >
                <Typography
                    variant="bodySubtext"
                    color={ColoursObj.font.secondary}
                >
                    Viewing
                </Typography>
                <Typography
                    variant="bodyRegular"
                    style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        width: '100%',
                        textWrap: 'nowrap',
                        textAlign: 'center',
                    }}
                >
                    {getEventInfoV2().data.title}
                </Typography>
            </div>
        </div>
    )
}
